'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleModal = function () {
    function SimpleModal($element) {
        _classCallCheck(this, SimpleModal);

        this.$element = $element;
    }

    _createClass(SimpleModal, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.append) {
                var element = this.$element[0];
                var appendThis = element;
                if (this.level) {
                    for (var i = 0; i < Number(this.level); i++) {
                        appendThis = appendThis.parentNode;
                    }
                }
                document.querySelector(this.append).appendChild(appendThis);
            }
        }
    }]);

    return SimpleModal;
}();

SimpleModal.$inject = ['$element'];

_module3.default.component('simpleModal', {
    controller: SimpleModal,
    bindings: {
        // append selected element to.
        append: '@',
        // selected element parent level. if not set select this element (simple-modal).
        level: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/simpleModal/simpleModal.js
// module id = 501
// module chunks = 2